<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('certificates.name')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.name"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                    :placeholder="$t('certificates.name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .num_of_study_hours -->
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-31"
                :label="$t('certificates.certificate_background')"
                label-for="input-31"
              >
                <b-form-file
                  id="wildcard"
                  v-model="newItem.background_img"
                  accept="image/*"
                  :placeholder="$t('certificates.certificate_background')"
                />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('certificates.show_type')"
                label-for="input-2"
              >
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="Selected"
                    name="program_type"
                    value="1"
                    class="custom-control-primary"
                  >
                    {{ $t("certificates.vertical") }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="Selected"
                    name="program_type"
                    value="2"
                    class="custom-control-primary"
                  >
                    {{ $t("certificates.horizontal") }}
                  </b-form-radio>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()"  variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required } from "@validations";
import Controller from "../../../../Controllers/CertificationsController";
import config from "../../../../config/config";

const controller = new Controller();
export default {
  name: "CountriesForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
    };
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, "FormData");
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },
  },
};
</script>
